<template>
  <div class="unlockable-item">
    <img 
      :src="typeIcon" 
      :alt="typeLabel"
      class="unlockable-icon" 
    />
    <span class="unlockable-type">{{ typeLabel }}:</span>
    <span class="unlockable-name">{{ unlockable.itemable_name }}</span>
  </div>
</template>

<script>
/**
 * Unlockable Item component following SOLID principles
 * Single Responsibility: Display individual unlockable item
 * Interface Segregation: Only receives unlockable data
 */
export default {
  name: 'UnlockableItem',
  
  props: {
    unlockable: {
      type: Object,
      required: true
    }
  },
  
  computed: {
    /**
     * Get type label for display
     */
    typeLabel() {
      const typeMap = {
        'Exhibit': '證物',
        'Position': '場景',
        'Related': '相關人',
        'Timeline': '時間軸',
        'Testimony': '證詞'
      };
      return typeMap[this.unlockable.itemable_type] || this.unlockable.itemable_type;
    },
    
    /**
     * Get type icon
     */
    typeIcon() {
      const iconMap = {
        'Exhibit': require('@/assets/images/exhibit-icon.png'),
        'Position': require('@/assets/images/soul-icon.png'),
        'Related': require('@/assets/images/related-icon.png'),
        'Timeline': require('@/assets/images/time-icon.png'),
        'Testimony': require('@/assets/images/related-icon.png')
      };
      return iconMap[this.unlockable.itemable_type] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.unlockable-item {
  padding: 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    padding-left: 4px;
    border-radius: 4px;
  }
  
  .unlockable-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.8;
  }
  
  .unlockable-type {
    color: #666;
    font-size: 14px;
    font-weight: 500;
    min-width: fit-content;
  }
  
  .unlockable-name {
    font-weight: 600;
    color: #333;
    font-size: 14px;
    word-break: break-word;
  }
}

// Responsive design
@media (max-width: 768px) {
  .unlockable-item {
    gap: 6px;
    
    .unlockable-icon {
      width: 14px;
      height: 14px;
    }
    
    .unlockable-type,
    .unlockable-name {
      font-size: 13px;
    }
  }
}
</style>